
import { HttpMiscOutboundList,HttpCancelMiscOutbound,HttpSureMiscOutbound,HttpExportMiscOutbound} from '@/service/misc';
import TableList from "@components/templates/tablelist";

import comIndex from './update'
import { mapGetters } from 'vuex';
import mixin from '../mixin';

export default {
    mixins: [TableList, mixin],
    components:{
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                isManage: false,
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpMiscOutboundList,
       
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'add':
                    this.$router.push({
                        name: "miscOutboundDetail",
                        params: { type },
                    })
                    break;
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        alertbox:'alertbox',
                        showFooter:false,
                    }
                    break;
                case 'queryBlank':
                    window.open(this.$router.resolve({
                        name: "miscOutboundDetail",
                        params: { type:'query' },
                        query: { id: params },
                    }).href, '_blank');
                    break;
                case 'edit':
                    window.open(this.$router.resolve({
                        name: "miscOutboundDetail",
                        params: { type:'edit' },
                        query: { id: params },
                    }).href, '_blank');
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.cancel', { defaultValue: '取消' }),
                        width: 'middle',
                        showDesc: false,
                        params: { id: params },
                        ajaxRequest: HttpCancelMiscOutbound,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "cancelReason",
                                labelWidth: 'auto',
                                span: 24,
                                required: false,
                                label: this.$t('fbb.inbound.cancel_reason', { defaultValue: '取消原因' })
                            }
                        ]
                    };
                    break;
                    case "sure":
                        this.operate = {
                            show: true,
                            alert: "error",
                            title: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
                            width: 'middle',
                            showDesc: false,
                            params: { id: params },
                            ajaxRequest: HttpSureMiscOutbound,
                            formdata: [
                                {
                                    tag: "vTextarea",
                                    key: "remark",
                                    labelWidth: 'auto',
                                    required: false,
                                    span: 24,
                                    label: this.$t('global.common.notes', { defaultValue: '备注' })
                                }
                            ]
                        };
                        break;
                 case 'export':
                    this.handleWebfs(HttpExportMiscOutbound, this.formData, { executor: 'request', download: true });
                    break;
               
               
            }
        },
        getOperateNodeMap(row) {
            const { id, miscOutboundStatus } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show: miscOutboundStatus == 0 ,
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
                show: miscOutboundStatus == 0 ,
                params: id,
                operate: 'sure'
            }, {
                label: this.$t('global.common.cancel', { defaultValue: '取消' }),
                show: miscOutboundStatus == 0 ,
                params: id,
                operate: 'cancel'
            },
          ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getOrgList', 'getProductList', 'getBillcusAndFbaWareList','getUserManageWarehouseList','getSelfmanageorgList']),
        TabsData() {
            return [
                {
                    name: this.$t('global.common.all', { defaultValue: "全部" }),
                    key: 'EQ_miscOutboundStatus',
                    val: null,
                },
                {
                    name: this.$t('fbb.headlogistics.draft', { defaultValue: "草稿" }),
                    key: 'EQ_miscOutboundStatus',
                    val: 0,
                },
                {
                    name: this.$t('global.common.finished', { defaultValue: "已完成" }),
                    key: "EQ_miscOutboundStatus",
                    val: 70,
                },
                {
                    name: this.$t('erp.b2c.orderstatus_canceled', { defaultValue: "已取消" }),
                    key: "EQ_miscOutboundStatus",
                    val: 90,
                },
            ]
        },
        ToolsData() {
            return [{
                name: this.$t('global.common.add', { defaultValue: '添加' }),
                operate: "add",
                theme: "primary",
            }, {
                name: this.$t('global.common.export', { defaultValue: '导出' }),
                operate: "export",
            }]
        },
        SearchsData() {
            return [{
                    label: this.$t('fbb.inbound.client_organization', { defaultValue: '客户组织' }),
                    key: 'EQ_organizationId',
                    tag: 'vSelect',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.misc.outbound_no', { defaultValue: '其他出库单号' }),
                    key: 'CN_miscOutboundNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.source_number', { defaultValue: '来源单号' }),
                    key: 'EQ_sourceNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'IN_miscOutboundStatus',
                    tag: 'vSelect',
                    options: this.getBillStatus,
                    props:{
                        multiple:true
                    }
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'EQ_orgWarehouseCode',
                    show: true,
                    tag: 'vSelect',
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.costmanage.work_type', { defaultValue: '业务类型' }),
                    key: 'EQ_type',
                    tag: 'vSelect',
                    options: this.getOutType,
                },
                {
                    label: this.$t('fbb.account.cusdisacountrate_source_type', { defaultValue: '来源类型' }),
                    key: 'EQ_srcLabel',
                    tag: 'vSelect',
                    options: this.getSrcLabel,
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    key: 'EQ_inventoryType',
                    tag: 'vSelect',
                    options: this.getInventoryType,
                },
                {
                    label: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    more: true,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                }
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                },{
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    width: 100,
                    render: (h, {
                        row
                    }) => this.findRenderLabel(this.getOrgList, row.organizationId)
                }, {
                    title: this.$t('fbb.misc.outbound_no', { defaultValue: '其他出库单号' })+'/'+this.$t('global.common.source_number', { defaultValue: '来源单号' }),
                    render: (h, { row }) => {
                        return <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.miscOutboundNo || '--'}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            <br />
                            {row.sourceNo || '--'}
                        </div>
                    }
                }, {
                    title: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'orgWarehouseCode',
                }, {
                    title: this.$t('fbb.account.cusdisacountrate_source_type', { defaultValue: '来源类型' }),
                    key: 'srcLabel',
                    render: (h, {
                        row
                    }) => this.findRenderLabel(this.getSrcLabel, row.srcLabel)
                }, {
                    title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    key: 'inventoryType',
                    render: (h, {
                        row
                    }) => this.findRenderLabel(this.getInventoryType, row.inventoryType)
                },{
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'miscOutboundStatus',
                    render: (h, { row }) => {
                        const status = row.miscOutboundStatus;
                        const { theme = 'default', label } = this.getBillStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{label}</vButton>
                    }
                }, {
                    title: this.$t('fbb.costmanage.work_type', { defaultValue: '业务类型' }),
                    key: 'type',
                    render: (h, {
                        row
                    }) => this.findRenderLabel(this.getOutType, row.type)
                },
                {
                    title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: 'createdAt',
                    sortable:true,
                }];
        },
    },
};




